import React from 'react';
import { ErrorCode } from 'react-dropzone';

import { FileExtension } from '@/common/constants';
import { Document } from '@/common/types';

export enum FileErrorCode {
  FileInvalidType = ErrorCode.FileInvalidType,
  FileTooLarge = ErrorCode.FileTooLarge,
  FileTooSmall = ErrorCode.FileTooSmall,
  TooManyFiles = ErrorCode.TooManyFiles,
  InvalidFile = 'invalid-file',
  DocumentNameIsTooLong = 'document-name-is-too-long',
  PasswordProtectedDocument = 'password-protected-document',
  PasswordProtectedFile = 'password-protected-file',
}

export enum ServerFileErrorMessage {
  DocumentNameIsTooLong = 'Document name is too long',
  PasswordProtectedDocument = 'Document is password protected',
  PasswordProtectedFile = 'File is password protected',
}

export const Signatures: Partial<Record<FileExtension, string[]>> = {
  [FileExtension.PDF]: ['%PDF-'],
};

export interface DocumentPagePreview extends Document {
  pageRef?: React.RefObject<HTMLDivElement | null> | null;
}
